module.exports = __webpack_public_path__ + "e20cc03a903c3b337197296756c9b0cf.svg";